import { ColorDynamic } from '@superdispatch/ui';
import { Box } from '@superdispatch/ui-lab';
import styled from 'styled-components';

const GRADIENT = `${ColorDynamic.Yellow50} 0%, ${ColorDynamic.Red50} 10%, ${ColorDynamic.Transparent} 28%`;

export const InstantTransferBannerGradientBox = styled(Box)`
  background: ${ColorDynamic.White};
  border: 1.5px solid ${ColorDynamic.Silver400};
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 52px;
  padding: 15px;
  position: relative;
  z-index: 1;

  &:before {
    content: '';
    background: linear-gradient(90deg, ${GRADIENT});
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: -1;
  }

  &:after {
    content: '';
    background: linear-gradient(270deg, ${GRADIENT});
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: -1;
  }
`;
